/*global gaEvent, sprintf, myModal, tooltip, urlParser, myDataLayer, analyticEventTracker, relaxPackage, myCookie, intlTelinputI18n, inputDirectionChange, abTest458 */

var bp = {
    init: function() {
        bp.action();
        bp.insurance();
        bp.extra();
        bp.referral();
        bp.calculator();
        bp.searchAgain();
        bp.expandInstructions();
        bp.validate();
        bp.externalCoverage();
        bp.coverage();
        bp.bookFromAlert();
        bp.deliveryCarModalConfirm();
        bp.upsellCars();
        bp.startStopWatch();
        bp.phone($('#driverPhone')[0]);
        bp.residenceWithFlag();
        bp.stateField();
    },
    isReferralEmailUsed: false,
    isCreateReservationFromAlert: false,
    iti: null,
    validator: false,
    buttonClicked: false,
    buttonHandler: '',
    driverFormActive: false,
    isRelaxPackageAvailable: (typeof relaxPackage !== 'undefined'),
    bookNowButtonTapEventInProgress: false,
    bookNowButtonTapErrorEventInProgress: false,
    hasLastNameBeenCheckedForDuplicate: false,
    isModification: _d.isModification,
    loadingTimeout: null,
    action: function() {
        $('.booking-form input').on('focus', function() {
            bp.sendCheckoutEvent();
        });

        $('.booking-form select').on('change', function() {
            bp.sendCheckoutEvent();
        });

        $('.more-extras').on('click', function(e) {
            e.preventDefault();
            $(this).remove();
            $('.extra-block').removeClass('hide');
        });

        $('.add-field').on('click', function(e) {
            e.preventDefault();
            var that = $(this),
                view = that.data('view');

            that.parent().hide();
            $('.hidden-field.' + view).show();
        });

        var isReference = urlParser.init(),
            scrollToDriverForm = (typeof isReference.get !== 'undefined' && typeof isReference.get.driverForm !== 'undefined');

        if (scrollToDriverForm) {
            $('html,body').animate({
                scrollTop: $('#driverFormBlock').offset().top - 12
            }, 700);
        }

        $('.modal-close').on('click', function() {
            if ($('.login-left-side').is(':visible')) {
                $('#createReservation').prop('disabled', false);
                $('.book-from-alert-btn').prop('disabled', false);
            }
        });

        $('#driverLastName').focusout(function() {
            if (bp.hasLastNameBeenCheckedForDuplicate) {
                return;
            }

            let lastName = $(this).val().toLowerCase();
            let lastNameIsEntered = lastName.length > 0;
            let firstName = $('#driverName').val().toLowerCase();
            let firstNameIsEntered = firstName.length > 0 && firstName !== 'test';

            if (
                firstNameIsEntered === true &&
                lastNameIsEntered === true
            ) {
                bp.hasLastNameBeenCheckedForDuplicate = true;
                if (firstName === lastName) {
                    $(this).val('');
                    analyticEventTracker.sendInstantEvent('Offer_SameNameAndLastName');
                }
            }
        });

        $('#driverEmail').emailautocomplete({
            suggClass: 'email-autocomplete',
            domains: ['example.com']
        });

        inputDirectionChange.onChangeAction('input,textarea');
    },
    extra: function() {

        $('.extra-item-select').each(function() {
            var that = $(this),
                count = parseInt(that.val()),
                amountForFree = parseInt(that.data('amount-for-free')),
                handler = $('[data-extra-id="' + that.data('id') + '"]'),
                summary = $('#b-price-summary'),
                currency = summary.data('currency'),
                mask = summary.data('currency-mask'),
                priceObject = that.parent().prev();

            if (count > 1) {
                handler.find('.extra-count').html('(' + count + ')');
            }
            bp.extraSelected(count, that);

            if (count > 0) {
                var days = parseInt(handler.data('days')),
                    type = parseInt(handler.data('price-type')),
                    price = parseFloat(handler.data('price'));

                if (amountForFree > 0) {
                    if (count > amountForFree) {
                        priceObject.find('.for-free').addClass('hidden');
                        handler.find('.for-free').addClass('hidden');
                        priceObject.find('.must-pay').removeClass('hidden');
                        handler.find('.amount-for-free').removeClass('hidden');
                    } else {
                        priceObject.find('.must-pay').addClass('hidden');
                        handler.find('.amount-for-free').addClass('hidden');
                        priceObject.find('.for-free').removeClass('hidden');
                        handler.find('.for-free').removeClass('hidden');
                    }

                    if (count === amountForFree) {
                        price = 0;
                    } else {
                        count = count - amountForFree;

                        if (count < 0) {
                            count = 0;
                        }
                    }
                }

                if (type === 1) {
                    price = price * days * count;
                } else {
                    price = price * count;
                }

                handler.removeClass('hide').find('.price-item-digit').html(sprintf(mask, price.toFixed(2), currency));
            }
        }).on('change', function() {
            var that = $(this),
                count = parseInt(that.val()),
                amountForFree = parseInt(that.data('amount-for-free')),
                handler = $('[data-extra-id="' + that.data('id') + '"]'),
                summary = $('#b-price-summary'),
                currency = summary.data('currency'),
                mask = summary.data('currency-mask'),
                priceObject = that.parent().prev();

            handler.find('.extra-count').html(count > 1 ? '(' + count + ')' : '');

            bp.extraSelected(count, that);

            if (count > 0) {
                var days = parseInt(handler.data('days')),
                    type = parseInt(handler.data('price-type')),
                    price = parseFloat(handler.data('price'));

                if (amountForFree > 0) {
                    if (count > amountForFree) {
                        priceObject.find('.for-free').addClass('hidden');
                        handler.find('.for-free').addClass('hidden');
                        priceObject.find('.must-pay').removeClass('hidden');
                        handler.find('.amount-for-free').removeClass('hidden');
                    } else {
                        priceObject.find('.must-pay').addClass('hidden');
                        handler.find('.amount-for-free').addClass('hidden');
                        priceObject.find('.for-free').removeClass('hidden');
                        handler.find('.for-free').removeClass('hidden');
                    }

                    if (count === amountForFree) {
                        price = 0;
                    } else {
                        count = count - amountForFree;

                        if (count < 0) {
                            count = 0;
                        }
                    }
                }

                if (type === 1) {
                    price = price * days * count;
                } else {
                    price = price * count;
                }

                handler.removeClass('hide').find('.price-item-digit').html(sprintf(mask, price.toFixed(2), currency));
                bp.calculator();
            } else {
                priceObject.find('.must-pay').hide();
                priceObject.find('.for-free').show();

                that.parent().removeClass('active');
                handler.addClass('hide');
                bp.calculator();
            }
        });
    },
    extraSelected: function(count, el) {
        if (count > 1) {
            el.prev().html(count).addClass('active').removeClass('selected');

        } else if (count === 0) {
            el.prev().html('').removeClass('active selected');
        } else {
            el.prev().html('').addClass('active selected');
        }
    },
    insurance: function() {
        if (bp.isRelaxPackageAvailable) {
            bp.relaxPackage();
        }

        $('.insurance-select').on('change', function() {
            if (bp.isRelaxPackageAvailable) {
                bp.relaxPackage();
            }
            bp.calculator();
        });

        $('.full-coverage-checkbox').on('click', function(e) {
            e.preventDefault();
            const that = $(this);
            const type = that.data('type');
            const checkbox = $('.fc-insurance');
            const notificationWarning = $('.full-coverage-removed');
            const notificationSuccess = $('.full-coverage-added');
            const textChecked = that.data('text-checked');

            if (that.hasClass('checked')) {
                return false;
            }

            $('.full-coverage-checkbox').each(function() {
                const checkbox = $(this);
                const textUnchecked = checkbox.data('text-unchecked');
                checkbox.removeClass('checked').find('div').text(textUnchecked);
            });

            if (type === 'full-coverage-yes') {
                notificationWarning.hide();
                notificationSuccess.show();
                checkbox.prop('checked', true);
            } else {
                notificationSuccess.hide();
                notificationWarning.show();
                checkbox.prop('checked', false);
            }

            that.addClass('checked').blur().find('div').text(textChecked);
            $('.full-coverage-choose').removeClass('full-coverage-checked').filter('.' + type).addClass('full-coverage-checked');

            if (bp.isRelaxPackageAvailable) {
                bp.relaxPackage();
            }

            bp.calculator();
        });

        $('.protection-radio').on('change', function(e) {
            bp.calculator();
            bp.insuranceToggle(e);
        });

        $('.full-coverage-button').on('click', function(e) {
            e.preventDefault();
            const type = $(this).data('type');

            $('#full-coverage-wrapper, #driver-form-preview-block').hide();
            $('#driverFormBlock, #insurance-preview-block').removeClass('hide');
            $('.insurance-select').prop('checked', type === 'add');
            $('.full-coverage-preview-block').hide().filter('.' + type).show();
            bp.calculator();
        });

        $('.edit-insurance').on('click', function() {
            $('#full-coverage-wrapper, #driver-form-preview-block').show();
            $('#driverFormBlock, #insurance-preview-block').addClass('hide');
        });
    },
    insuranceToggle: function(e) {
        const { target: { value } } = e;

        const insuranceAddedSelector = '.full-coverage-added';
        const insuranceRemovedSelector = '.full-coverage-removed';

        function toggleElementsVisibility(selector, isAdd) {
            $(selector).each(function() {
                if (isAdd) {
                    $(this).addClass('hide');
                } else {
                    $(this).removeClass('hide');
                }
            });
        }

        switch (value) {
            case '1':
                toggleElementsVisibility(insuranceAddedSelector, false);
                toggleElementsVisibility(insuranceRemovedSelector, true);
                break;
            case '0':
                toggleElementsVisibility(insuranceAddedSelector, true);
                toggleElementsVisibility(insuranceRemovedSelector, false);
                break;
            default:
        }
    },
    sendCheckoutEvent: function() {
        if (!bp.driverFormActive) {
            bp.driverFormActive = true;
            myDataLayer.send('booking');
        }
    },
    toggleInsuranceInputs: function(el, isChecked) {
        const id = el.data('id');

        if (!isChecked) {
            $('[data-insurance-id="' + id + '"]').addClass('hide');
        } else {
            $('[data-insurance-id="' + id + '"]').removeClass('hide');
        }
    },
    calculator: function() {
        let summary = $('#b-price-summary');
        let mandatoryExtrasPayableNow = parseFloat(summary.data('mandatory-extra-pay-now'));
        let payableNow = parseFloat(summary.data('commission')) + mandatoryExtrasPayableNow;
        let payableOnArrival = parseFloat(summary.data('on-arrival'));
        let currency = summary.data('currency');
        let showTotalHandler = false;
        let totalHandler = $('.total-sum');
        let mask = summary.data('currency-mask');
        let referralBcAmount = Number(_d.referral.bcAmount);
        let appliedReferralBcAmount = 0;

        $('.insurance-select').each(function() {
            const that = $(this);
            const id = that.data('id');
            const isChecked = that.is(':checked');

            bp.toggleInsuranceInputs(that, isChecked);

            if (bp.isRelaxPackageAvailable) {
                $('[data-insurance-id="' + id + '"]').addClass('hide');
            }
        });

        $('.insurance-select-radio:checked').each(function() {
            const that = $(this);
            /* Yes/No radio buttons */
            const isChecked = $(this).val() === '1';
            bp.toggleInsuranceInputs(that, isChecked);
        });

        if (bp.isRelaxPackageAvailable) {
            let relaxPackage = $('[data-relax-package="true"]:visible');
            let relaxPackagePrice = relaxPackage.length > 0 ? parseFloat(relaxPackage.data('price')) : 0;
            payableNow = payableNow + relaxPackagePrice;
        }

        $('.payable-now:visible').each(function() {
            let that = $(this);
            let price = parseFloat(that.data('price'));
            let amountForFree = parseInt(that.data('amount-for-free'));
            let days = that.data('days');
            let type = that.data('price-type');
            let id = that.data('extra-id');
            let count = $('[data-id="' + id + '"]').val();

            if (count === undefined) {
                count = (typeof that.data('count') !== 'undefined' ? parseInt(that.data('count')) : 1);
            }

            if (days === undefined) {
                days = 1;
            }

            if (amountForFree > 0) {
                if (count === amountForFree) {
                    price = 0;
                } else {
                    count = count - amountForFree;

                    if (count < 0) {
                        count = 0;
                    }
                }
            }

            if (type === 1) {
                price = price * days * count;
            } else {
                price = price * count;
            }

            payableNow = payableNow + price;
        });

        // Referral bonus calculation. It's type of BC, hence done based on Pay Now amount
        if (referralBcAmount > 0 && bp.isReferralEmailUsed) {
            appliedReferralBcAmount = Math.min(payableNow, referralBcAmount);
            payableNow = payableNow > referralBcAmount ? payableNow - referralBcAmount : 0;
        }

        $('.payable-on-arrival:visible').each(function() {
            let that = $(this);
            let price = parseFloat(that.data('price'));
            let amountForFree = parseInt(that.data('amount-for-free'));
            let days = that.data('days');
            let type = that.data('price-type');
            let id = that.data('extra-id');
            let count = $('[data-id="' + id + '"]').val();

            if (count === undefined) {
                count = (typeof that.data('count') !== 'undefined' ? parseInt(that.data('count')) : 1);
            }

            if (days === undefined) {
                days = 1;
            }

            if (amountForFree > 0) {
                if (count === amountForFree) {
                    price = 0;
                } else {
                    count = count - amountForFree;

                    if (count < 0) {
                        count = 0;
                    }
                }
            }

            if (type === 1) {
                price = price * days * count;
            } else {
                price = price * count;
            }

            payableOnArrival = payableOnArrival + price;

        });

        const total = payableNow + payableOnArrival;
        const totalSum = sprintf(mask, total.toFixed(2), currency);

        if (payableNow === 0.00) {
            $('#createReservation').find('div').text(_d.t.bookPayLater);
        } else {
            $('#createReservation').find('div').text(_d.t.continueToPayment);
        }

        payableNow = sprintf(mask, payableNow.toFixed(2), currency);
        payableOnArrival = sprintf(mask, payableOnArrival.toFixed(2), currency);

        if (appliedReferralBcAmount > 0) {
            appliedReferralBcAmount = `-${sprintf(mask, appliedReferralBcAmount.toFixed(2), currency)}`;
            $('#amount-referral-bc .price-item-digit').html(appliedReferralBcAmount);
            $('#amount-referral-bc').removeClass('hide');
        } else {
            $('#amount-referral-bc').addClass('hide');
        }

        if ($('.summary-item:not(.hide,.hide-important)').length > 1) {
            showTotalHandler = true;
        }

        if (showTotalHandler) {
            totalHandler.show();
        } else {
            totalHandler.hide();
        }

        $('#total-sum, #total-sum-main').html(totalSum);
        $('#amount-payable-now').html(payableNow);
        $('#amount-payable-on-arrival').html(payableOnArrival);
    },
    validate: function() {
        $.validator.addMethod('onlyLatin', function(val, el) {
            var latinMatch = /^[a-zA-Z\.\'\-\s]+$/,
                data = [],
                fName = $(el).attr('name'),
                noError = latinMatch.test(val.trim()) !== false;

            if (!noError) {
                dataLayer.push({
                    'onlyLatin': {
                        'action': val
                    },
                    'event': 'onlyLatin'
                });

                if (fName === 'driver_firstname' && !bp.fne) {
                    bp.fne = true;

                    data.field = 'firstname';
                    data.init = val;
                    data.device = 'mobile';
                    bp.log(data);
                }

                if (fName === 'driver_lastname' && !bp.lne) {
                    bp.lne = true;

                    data.field = 'lastname';
                    data.init = val;
                    data.device = 'mobile';
                    bp.log(data);
                }
            } else {
                if (bp.fne && fName === 'driver_firstname') {
                    data.field = 'firstname';
                    data.new = val;
                    bp.log(data);
                    bp.fne = false;
                }

                if (bp.lne && fName === 'driver_lastname') {
                    data.field = 'lastname';
                    data.new = val;
                    bp.log(data);
                    bp.lne = false;
                }
            }

            return noError;
        });

        $('#createReservation').on('click', function() {
            bp.buttonClicked = true;
            bp.buttonHandler = $(this);

            if (bp.buttonClicked && !bp.bookNowButtonTapEventInProgress) {
                let postData = bp.formatBookNowTapEventPostData();
                analyticEventTracker.trackEvent(postData);
                bp.bookNowButtonTapEventInProgress = true;

                setTimeout(function() {
                    bp.bookNowButtonTapEventInProgress = false;
                }, 1000);
            }

            setTimeout(function() {
                bp.buttonClicked = false;
            }, 200);
        });

        bp.validator = $('#booking-form').validate({
            ignore: null,
            errorClass: 'error',
            errorElement: 'div',
            focusInvalid: false,
            groups: {
                dob: 'driver_birth_dt_day driver_birth_dt_month driver_birth_dt_year'
            },
            errorPlacement: function(error, el) {
                $(el).parents('.booking-form-row-cell').find('.error-message').append(error);
            },
            highlight: function(el, ec) {
                const handler = $(el);
                const isSelect = (handler[0].localName === 'select');

                if (bp.buttonClicked) {
                    dataLayer.push({
                        'driverDetailsError': {
                            'label': handler[0].name.replace('driver_', '')
                        },
                        'event': 'driverDetailsError'
                    });
                }

                if (isSelect) {
                    handler.parent().addClass('red');
                } else {
                    handler.addClass(ec);
                }
            },
            showErrors: function(errorMap, errorList) {
                if (bp.buttonClicked && !bp.bookNowButtonTapErrorEventInProgress && errorList.length) {
                    let postData = bp.formatBookNowTapErrorEventPostData(errorList);
                    analyticEventTracker.trackEvent(postData);
                    bp.bookNowButtonTapErrorEventInProgress = true;

                    setTimeout(function() {
                        bp.bookNowButtonTapErrorEventInProgress = false;
                    }, 1000);
                }

                setTimeout(function() {
                    bp.getErrors();
                }, 100);

                this.defaultShowErrors();
            },
            unhighlight: function(el, ec) {
                const handler = $(el);
                const isSelect = (handler[0].localName === 'select');

                if (isSelect) {
                    handler.parent().removeClass('red');
                } else {
                    handler.removeClass(ec);
                }
            },
            submitHandler: function() {
                bp.startStopWatch();
                bp.createReservation();
            },
            rules: {
                driver_email: {
                    email: false
                }
            }
        });
    },
    createReservation: function() {
        let form = {};
        const btn = bp.buttonHandler;
        const btns = $('.create-reservation');
        const btnsFromAlert = $('.book-from-alert-btn');

        $('input, select, textarea, label', '#booking-form').each(function() {
            var that = $(this);

            if (that.is('label') || bp.isDisabledFieldIgnored(that)) {
                return true;
            }

            if (that.attr('type') === 'checkbox') {
                form[that.attr('name')] = (that.is(':checked') ? 1 : 0);
            } else if ($(this).attr('type') === 'radio') {
                if ($(this).is(':checked')) {
                    form[$(this).attr('name')] = $(this).val();
                }
            } else if (typeof that.attr('name') !== 'undefined') {
                form[that.attr('name')] = that.val();
            }
        });

        const insuranceType = $('#insuranceType').data('insurance-type');
        const isInsuranceAdded = $('#insurance-add').is(':checked');

        if (
            !bp.isCreateReservationFromAlert
            && !isInsuranceAdded
        ) {
            if (insuranceType === Number(_d.insurances.externalCoverageType)) {
                bp.openExternalCoverageAlertModal();
                return;
            } else if (insuranceType && typeof abTest458 !== 'undefined' && abTest458 === 1) {
                bp.openFullCoverageAlertModal();
                return;
            } else if (insuranceType === Number(_d.insurances.rentalCoverCdwType)) {
                bp.openRentalCoverCdwAlertModal();
                return;
            }
        }

        bp.isCreateReservationFromAlert = false;

        btns.prop('disabled', true);
        btn.addClass('loading');
        bp.loadingTimeout = setTimeout(function() {
            myModal.openStaticModal('reservationCreationModal', {modalWindowClass: 'w-360', noHeader: true, noCloseButtonInHeader: true});
        }, 5000);

        myDataLayer.send('submitted-booking-form');
        myDataLayer.send('selected-extras-count');

        if ($('#subscribe-news').is(':checked')) {
            myDataLayer.send('marketing-checkbox');
        }

        $.postJSON(form.proceed_url, form, function(response) {
            clearTimeout(bp.loadingTimeout);

            if (!response.error) {
                bp.sendCheckoutEvent();
                document.location.href = response.paymentUrl;
            } else {
                myModal.close(0);
                btns.prop('disabled', false);
                btn.removeClass('loading');
                btnsFromAlert.prop('disabled', false);
                btnsFromAlert.removeClass('loading');

                if (typeof response.message.recheck !== 'undefined') {
                    myModal.staticModal(response.message.recheckType + 'Modal', {
                        msg: response.message.recheck
                    });
                } else if (typeof response.message.unable !== 'undefined') {
                    myModal.staticModal('unableCreateReservationModal', {msg: response.message.unable});
                } else if (typeof response.message.expired !== 'undefined') {
                    myModal.staticModal('expiredResultsModal');
                } else {
                    let errStr = '';

                    $.each(response.message, function(element, message) {
                        const handler = $('[name="' + element + '"]');

                        if (handler.length > 0) {
                            if (handler.get(0).type === 'select-one') {
                                handler.parent().removeClass('success').addClass('error');
                            } else {
                                handler.removeClass('success').addClass('error');
                            }
                        }

                        if (message.trim()) {
                            errStr = errStr || message;
                        }
                    });

                    bp.validator.showErrors(response.message);
                }
            }
        });
    },
    searchAgain: function() {
        if ($('.create-reservation.disabled').length > 0) {
            myModal.staticModal('expiredResultsModal');
        }
    },
    expandInstructions: function() {
        $('.toggle-instructions').on('click', function(e) {
            e.preventDefault();
            var that = $(this),
                more = that.data('more-text'),
                less = that.data('less-text'),
                mode = that.data('mode');

            $('[data-' + mode + '-hide], [data-' + mode + '-show]').toggle();

            that.text((that.hasClass('less') ? more : less)).toggleClass('less');
        });
    },
    log: function(data) {
        $.postJSON(_d.url.reservation.logOnlyLatin, data);
    },
    relaxPackage: function() {
        $('.insurance-select.relax-package').each(function() {
            const that = $(this);
            const isChecked = that.is(':checked');
            const relaxPackageItems = $('.relax-package-column');
            const relaxPackageFilter= isChecked ? '.relax-package' : '.basic-package';

            relaxPackageItems.removeClass('active');
            relaxPackageItems.filter(relaxPackageFilter).addClass('active');

            if (isChecked) {
                $('[data-relax-package="true"]').removeClass('hide');
                $('[data-relax-package="false"]').addClass('hide');
            } else {
                $('[data-relax-package="true"]').addClass('hide');
                $('[data-relax-package="false"]').removeClass('hide');
            }
        });
    },
    formatBookNowTapErrorEventPostData: function(errorMap) {
        return {
            eventName: 'Offer_BookNowButtonTapError',
            attributes: {
                'attributeDriverName': bp.getFieldErrorById(errorMap, 'driverName'),
                'attributeDriverLastName': bp.getFieldErrorById(errorMap, 'driverLastName'),
                'attributeDriverEmail': bp.getFieldErrorById(errorMap, 'driverEmail'),
                'attributeDriverPhoneCountryCode': bp.getFieldErrorById(errorMap, 'phoneCountryCode'),
                'attributeDriverPhone': bp.getFieldErrorById(errorMap, 'driverPhone'),
                'attributeDriverBirthDay': bp.getFieldErrorById(errorMap, 'driver_birth_dt_day'),
                'attributeDriverBirthMonth': bp.getFieldErrorById(errorMap, 'driver_birth_dt_month'),
                'attributeDriverBirthYear': bp.getFieldErrorById(errorMap, 'driver_birth_dt_year'),
                'attributeDriverRestriction': 'unchecked',
                'attributeModification': bp.isModification
            }
        };
    },
    formatBookNowTapEventPostData: function() {
        return {
            eventName: 'Offer_BookNowButtonTap',
            attributes: {
                'attributeDriverAdditionalRequirements': $('#driverComment').val() !== '',
                'attributeDriverFlightNumber': $('#driverFlightNr').val() !== '',
                'attributeModification': bp.isModification
            }
        };
    },
    getFieldErrorById(errorMap, fieldId) {
        let response = null;
        $.each(errorMap, function(key, value) {
            if (response === null) {
                response = $(value.element).attr('id') === fieldId ? $(errorMap[key]).attr('method') : null;
            }
        });

        return response ? response : 'Ok';
    },
    externalCoverage() {
        $('.full-protection-inclusion-title').on('click', function() {
            const that = $(this);

            that.toggleClass('opened');
            that.parent().find('.full-protection-inclusion-content').slideToggle();
        });
    },
    coverage() {
        $('.add-coverage-block-btn').on('click', function() {
            $(this).hide();
            $('.remove-coverage-block-btn').show();
            $('#insurance-add').prop('checked', true);
            bp.calculator();
        });

        $('.remove-coverage-block-btn').on('click', function() {
            $(this).hide();
            $('.add-coverage-block-btn').show();
            $('#insurance-skip').prop('checked', true);
            bp.calculator();
        });
    },
    deliveryCarModalConfirm() {
        $(document).on('click', '.deliveryCarModalConfirm', function() {
            $(this).closest('.modal-content').find('.modal-close').click();
        });
    },
    upsellCars() {
        const upsellBlock = $('#upsell-cars-content');
        const blockWrapper = $('#upsell-cars');
        const loader = $('#upsell-cars-loader');
        const GUID = upsellBlock.data('guid');
        const searchGUID = upsellBlock.data('search-guid');
        const carId = upsellBlock.data('car-id');

        if (!GUID) {
            return;
        }

        const url = _d.url.offer.upsellCarsBlock.replace('guid', GUID)
            .replace('searchGuid', searchGUID)
            .replace('carId', carId);

        fetch(url)
            .then((res) => res.json())
            .then((data) => {
                const { status, html } = data;

                if (status) {
                    upsellBlock.html(html);
                    loader.hide();
                } else {
                    blockWrapper.hide();
                }
            }).catch(() => {
                blockWrapper.hide();
            });
    },
    startStopWatch() {
        myCookie.setCookie('dch_pplsw', new Date().getTime(), 1);
    },
    phone: function(input) {
        bp.iti = window.intlTelInput(input, {
            initialCountry: input.dataset.initialCountry,
            separateDialCode: true,
            i18n: intlTelinputI18n,
            utilsScript: '/assets/vendor/js/intlTelInputUtils.min.js'
        });

        input.addEventListener('paste', function() {
            // Delay execution until after the paste event
            setTimeout(function() {
                const pastedText = input.value;
                const dialCode = bp.iti.getSelectedCountryData().dialCode;

                // Remove the country code if it is duplicated
                if (pastedText.startsWith(`+${dialCode}`)) {
                    input.value = pastedText.replace(`+${dialCode}`, '').trim();
                }
            });
        });

        input.addEventListener('input', function() {
            input.value = input.value.replace(/[^0-9\- ]/g, '');
        });

        bp.updateCountryCode();
        input.addEventListener('countrychange', function() {
            bp.updateCountryCode();
        });
    },
    updateCountryCode: function() {
        const countryData = bp.iti.getSelectedCountryData();
        $('#phoneCountryCode').val('+' + countryData.dialCode);
    },
    residenceWithFlag: function() {
        $('.phone-country-flag-block').on('click', function(e) {
            e.stopPropagation();
            setTimeout(function() {
                $('#residence').trigger('chosen:open');
            }, 0);
        });

        $('#residence').chosen({
            inherit_select_classes: true,
            no_results_text: _d.t.chosen_no_results_text,
            width: '100%',
            parser_config: { copy_data_attributes: true }
        }).on('blur', function() {
            $(this).trigger('chosen:updated');
        }).on('chosen:search_updated', function() {
            const $chosenResults = $('.chosen-results .active-result');
            $chosenResults.each(function() {
                $(this).html('<div class="flag-box"><i class="flag fl-' + $(this).data('value').toLowerCase() + '"></i></div><div>' + $(this).text() + '</div>');
            });
        }).on('change', function() {
            $('#residenceCountryFlag').removeAttr('class').attr('class', 'flag fl-' + $(this).val().toLowerCase());
        });
        inputDirectionChange.onChangeAction('.chosen-search-input');
    },
    stateField: function() {
        $('#us_state, #ca_state').chosen({
            inherit_select_classes: true,
            no_results_text: _d.t.chosen_no_results_text,
            width: '100%',
            parser_config: { copy_data_attributes: true },
            allow_single_deselect: true,
            placeholder_text_single: 'Select a state'
        }).on('blur', function() {
            $(this).trigger('chosen:updated');
        }).on('change', function() {
            $(this).valid();
        });

        inputDirectionChange.onChangeAction('.chosen-search-input');

        $('#residence').on('change', function() {
            const residenceCountry = $(this).val();
            const stateWrapper = $('.us-ca-state-form-row');
            const stateSelects = {
                'US': {
                    select: $('#us_state'),
                    wrapper: $('.us-state-field')
                },
                'CA': {
                    select: $('#ca_state'),
                    wrapper: $('.ca-state-field')
                }
            };

            const hasStates = Object.keys(stateSelects).includes(residenceCountry);

            stateWrapper.toggle(hasStates);

            Object.entries(stateSelects).forEach(([country, { select, wrapper }]) => {
                const isCurrentCountry = residenceCountry === country;

                wrapper.toggle(isCurrentCountry);
                select.prop('disabled', !isCurrentCountry);
                select.trigger('chosen:updated');
            });
        });
    },
    getErrors: function() {
        const errorElement = $('#single');
        const errorList = [];

        $('#booking-form').find('.booking-form-row-cell .error-message .error:visible').each(function() {
            errorList.push($(this).text());
        });

        const listItems = errorList.map(item => `<li>${item}</li>`).join('');
        $('#error-list').html(`<ul class="dc-ui list no-padding-y">${listItems}</ul>`);

        if (errorList.length > 0) {
            errorElement.show();
        } else {
            errorElement.hide();
        }
    },
    openExternalCoverageAlertModal: function() {
        myModal.openStaticModal(
            'externalCoverageAlertModal',
            { modalDialogClass: 'w-1120', modalBodyClass: 'w-1120', noHeader: true, noCloseButtonInHeader: true }
        );

        bp.externalCoverage();
    },
    openFullCoverageAlertModal: function() {
        myModal.openStaticModal(
            'fullCoverageAlertModal',
            { modalDialogClass: 'w-1120', modalBodyClass: 'w-1120', noHeader: true, noCloseButtonInHeader: true }
        );

        tooltip.init();
    },
    openRentalCoverCdwAlertModal: function() {
        myModal.openStaticModal(
            'rentalCoverCdwAlertModal',
            { modalDialogClass: 'w-1120', modalBodyClass: 'w-1120', noHeader: true, noCloseButtonInHeader: true }
        );

        bp.externalCoverage();
    },
    bookFromAlert: function() {
        $(document).on('click', '.book-from-alert-btn', function() {
            const that = $(this);
            const isWithInsurance = that.data('is-with-insurance') === 1;
            const createReservation = $('#createReservation');

            bp.isCreateReservationFromAlert = true;
            that.addClass('loading').prop('disabled', true);

            if (isWithInsurance) {
                $('#insurance-add').prop('checked', true);
            } else {
                $('#insurance-skip').prop('checked', true);
            }

            createReservation.click();
        });
    },
    isDisabledFieldIgnored: function(el) {
        return el.prop('disabled') && ['us_state', 'ca_state'].includes(el.attr('id'));
    },
    referral: function() {
        bp.email();
        $('#driverEmail').on('input', bp.email);
    },
    email: function() {
        const emailVal = $('#driverEmail').val();
        const prevIsReferralEmailUsed = bp.isReferralEmailUsed;

        bp.isReferralEmailUsed = emailVal.trim() === _d.referral.email;

        // Applying referral BC only to the specified email
        if (bp.isReferralEmailUsed !== prevIsReferralEmailUsed) {
            bp.calculator();
        }
    }
};
